/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreregisteredSocietyPostId
 */
export interface PreregisteredSocietyPostId {
    /**
     * 
     * @type {string}
     * @memberof PreregisteredSocietyPostId
     */
    id: string;
}

/**
 * Check if a given object implements the PreregisteredSocietyPostId interface.
 */
export function instanceOfPreregisteredSocietyPostId(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function PreregisteredSocietyPostIdFromJSON(json: any): PreregisteredSocietyPostId {
    return PreregisteredSocietyPostIdFromJSONTyped(json, false);
}

export function PreregisteredSocietyPostIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreregisteredSocietyPostId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function PreregisteredSocietyPostIdToJSON(value?: PreregisteredSocietyPostId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

